import angular from 'angular';

import commentsUrl from './comments.html';
import commentEditUrl from './comment-edit.html';

class CommentsCtrl {
  constructor(
    Mentions,
    Restangular,
    Upload,
    PersonaCollection,
    Authentication,
    AlertService,
    $window,
    $uibModal,
    $scope
  ) {
    'ngInject';

    Object.assign(this, {
      Mentions,
      Restangular,
      Upload,
      PersonaCollection,
      Authentication,
      AlertService,
      $window,
      $uibModal,
      $scope,
    });
  }

  $onInit() {
    this.shouldRenderTextEditor = !__TEST__;
    this.mentions = new this.Mentions(this.users);
    this.allCommentsLoaded = this.list.length >= this.count;
    this.loadingComments = false;
    this.hasAccessToUser = this.PersonaCollection.hasAccessToUser;
  }

  loadMoreComments() {
    if (!this.list.length) {
      return;
    }

    this.loadingComments = true;

    this.item
      .all('comments')
      .getList({ before: this.list[0].id })
      .then((data) => {
        const restangularized = this.Restangular.restangularizeCollection(null, data, 'comments');
        this.list = [...restangularized, ...this.list];

        if (data.length === 0 || this.list.length === this.count) {
          this.allCommentsLoaded = true;
        }

        this.loadingComments = false;
      });
  }

  submitRichText(text, attachments) {
    this.addComment({ content: text, attachments });
  }

  addComment(newComment) {
    const savedNewComment = angular.copy(newComment);
    angular.copy({}, newComment);

    this.item
      .all('comments')
      .post(savedNewComment)
      .catch((error) => {
        angular.copy(savedNewComment, newComment);
        console.log(error);
      });
  }

  deleteComment(comment) {
    comment.remove();
  }

  editComment(comment) {
    const controller = this;
    const modalInstance = this.$uibModal.open({
      templateUrl: commentEditUrl,
      controllerAs: 'ctrl',
      backdrop: 'static',
      controller(commentCopy) {
        'ngInject';

        this.comment = commentCopy;
        this.initialCommentContent = commentCopy.content;
        this.mentions = controller.mentions;
        this.attachmentsEnabled = controller.attachmentsEnabled;

        this.onContentChange = (text, attachments) => {
          this.comment.content = text;
          this.comment.attachments = attachments || [];
        };
        this.showErrorToast = controller.showErrorToast;
        this.Authentication = controller.Authentication;

        this.submitEdit = () =>
          this.comment.put().then(() => {
            modalInstance.close();
            return true;
          });

        if (this.comment.attachments?.length) {
          this.comment.attachments.forEach((attachment) => {
            const parts = attachment.url.split('/');
            attachment.fileName = decodeURIComponent(parts[parts.length - 1]);
          });
        }

        this.removeUpload = (index) => {
          this.comment.attachments.splice(index, 1);
        };
      },
      resolve: {
        commentCopy: () => this.Restangular.copy(comment),
      },
    });

    modalInstance.result.ignoreCancel();
  }

  removeUpload(index) {
    this.newComment.attachments.splice(index, 1);
  }

  showErrorToast = (error) => {
    if (error) {
      this.AlertService.danger(error);
    }
  };
}

export default {
  bindings: {
    item: '<',
    list: '<',
    count: '<',
    users: '<',
    attachmentsEnabled: '<',
    isLoading: '<',
  },
  templateUrl: commentsUrl,
  controller: CommentsCtrl,
  controllerAs: 'ctrl',
};
